import { dashboardDataTableStore } from "../stores/data-table.store";
import { dashboardEChartsStore } from "../stores/e-charts.store";

// "Seed and diverge": a top FilterBar change re-seeds the matching local
// filter on the bottom tabs (ESG data table, E data charts); the tabs keep
// their own controls and may diverge until the next top change. Only the
// dimension that changed up top is re-seeded, and only when the bottom
// model can express it:
//   - Year = Y   -> table years [Y]; charts strip year Y (range widens,
//     never collapses to a single year)
//   - Year = All -> no seed, the tab defaults stay
//   - Category   -> table categories, except General (the table's
//     vocabulary has no General)
//   - Organization: businessUnit or country lens with a concrete pick ->
//     table bus/countries, charts groupBy + entities; company, site, and
//     mixed (All-lens) picks are inexpressible below -> no seed
// Seeds run through the stores' setters, so an overridden seed resets the
// table's cleared flag: a top change is an explicit new context. On the charts
// a seed narrows only the dimension it names and exits any drill; the other
// dimension keeps the user's selection (R09 item 5 brief 3.2 item 1).

// Must match CATEGORY_VALUES in components/data-table-section/DataTableFilters.jsx.
const TABLE_CATEGORIES = new Set(["Environmental", "Social", "Governance"]);

const sameArray = (left = [], right = []) =>
  left.length === right.length &&
  left.every((value, index) => value === right[index]);

export const seedBottomTabFilters = (next, prev) => {
  if (!sameArray(next.years, prev.years) && next.years.length === 1) {
    const year = Number(next.years[0]);
    if (Number.isFinite(year)) {
      dashboardDataTableStore.setFilter("years", [year]);
      dashboardEChartsStore.seedSelectedYear(year);
    }
  }

  if (!sameArray(next.categories, prev.categories)) {
    const seedable = next.categories.filter((category) =>
      TABLE_CATEGORIES.has(category),
    );
    if (seedable.length > 0) {
      dashboardDataTableStore.setCategories(seedable);
    }
  }

  const orgChanged =
    next.hierarchy !== prev.hierarchy || !sameArray(next.orgIds, prev.orgIds);
  if (orgChanged && next.orgIds.length > 0) {
    const ids = next.orgIds.map(String);
    if (next.hierarchy === "businessUnit") {
      dashboardDataTableStore.setFilter("bus", ids);
      dashboardEChartsStore.seedEntities("bu", ids);
    } else if (next.hierarchy === "country") {
      dashboardDataTableStore.setFilter("countries", ids);
      dashboardEChartsStore.seedEntities("country", ids);
    }
  }
};
